import { memo } from 'react'

import Svg, { Path, G, Defs, ClipPath, Rect } from 'react-native-svg'

const EmailNotConfirmedIllustration = ({ width = 251, height = 250 }) => (
  <Svg width={width} height={height} viewBox="0 0 251 250" fill="none">
    <G clipPath="url(#clip0_8462_168397)">
      <Path
        d="M17.4702 243.97H230.6"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M60.3801 29.4C60.0101 27.5 59.0801 25.76 57.7201 24.38C56.3601 23 54.6201 22.06 52.7201 21.67C50.8301 21.27 48.8601 21.45 47.0601 22.17C45.2701 22.89 43.7201 24.13 42.6301 25.73C41.5301 27.32 40.9301 29.21 40.9001 31.14C40.8701 33.08 41.4101 34.98 42.4601 36.61C43.1701 37.7 44.1001 38.64 45.1701 39.37C46.2501 40.1 47.4701 40.62 48.7401 40.88C50.0201 41.15 51.3401 41.16 52.6201 40.91C53.9001 40.67 55.1201 40.17 56.2101 39.46C57.8201 38.38 59.0701 36.85 59.8101 35.06C60.5501 33.27 60.7501 31.3 60.3801 29.4ZM44.9801 30.15C45.0901 29.32 45.3901 28.53 45.8401 27.83C46.2901 27.13 46.8901 26.54 47.5901 26.09C48.9301 25.25 50.5401 24.97 52.0901 25.32C53.6301 25.66 54.9801 26.61 55.8301 27.94L44.9801 30.15ZM55.1501 35.45C54.3301 36.29 53.2701 36.86 52.1101 37.1C50.9601 37.33 49.7601 37.22 48.6701 36.77C47.5801 36.31 46.6501 35.55 46.0001 34.56L56.7501 32.38C56.5401 33.54 55.9801 34.61 55.1501 35.45Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M55.83 27.94L44.98 30.15C45.09 29.32 45.39 28.53 45.84 27.83C46.29 27.13 46.89 26.54 47.59 26.09C48.93 25.25 50.54 24.97 52.09 25.32C53.63 25.66 54.98 26.61 55.83 27.94V27.94Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M56.75 32.3799C56.54 33.5399 55.98 34.6099 55.15 35.4499C54.33 36.2899 53.27 36.8599 52.11 37.0999C50.96 37.3299 49.76 37.2199 48.67 36.7699C47.58 36.3099 46.65 35.5499 46 34.5599L56.75 32.3799Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M56.75 32.3799C56.54 33.5399 55.98 34.6099 55.15 35.4499C54.33 36.2899 53.27 36.8599 52.11 37.0999C50.96 37.3299 49.76 37.2199 48.67 36.7699C47.58 36.3099 46.65 35.5499 46 34.5599L56.75 32.3799Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M55.83 27.94L44.98 30.15C45.09 29.32 45.39 28.53 45.84 27.83C46.29 27.13 46.89 26.54 47.59 26.09C48.93 25.25 50.54 24.97 52.09 25.32C53.63 25.66 54.98 26.61 55.83 27.94V27.94Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M192.08 212.55L196.95 210.7"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M205.57 207.42L210.44 205.57"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M197.76 199.89L199.61 204.74"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M202.91 213.38L204.76 218.23"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M192.32 205.04L197.05 207.18"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M205.48 210.93L210.23 213.07"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M205.28 200.1L203.14 204.85"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M199.37 213.26L197.26 218.01"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M28.4199 167.83L31.0799 181.15"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M36.4201 173.17L23.1001 175.83"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M232.53 87.62C232.53 88.03 232.41 88.44 232.18 88.78C231.95 89.12 231.62 89.39 231.24 89.55C230.86 89.71 230.44 89.75 230.03 89.67C229.62 89.59 229.25 89.39 228.96 89.1C228.67 88.81 228.47 88.44 228.39 88.03C228.31 87.62 228.35 87.2 228.51 86.82C228.67 86.44 228.94 86.11 229.28 85.88C229.62 85.65 230.03 85.53 230.44 85.53C230.99 85.53 231.53 85.75 231.92 86.14C232.31 86.53 232.53 87.06 232.53 87.62V87.62Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M213.63 109.94C213.63 111.87 213.21 113.77 212.41 115.53L175.27 196.75C174.2 199.08 172.49 201.06 170.35 202.46C168.2 203.86 165.7 204.62 163.14 204.66L142.85 196.82L102.31 178.28L78.01 167.16L71.53 164.19L69.84 163.43L61.77 159.73L53.2 155.81L36 147.92C34.38 147.19 32.92 146.14 31.71 144.83C30.5 143.53 29.55 142 28.93 140.33C28.31 138.66 28.03 136.89 28.09 135.11C28.16 133.33 28.58 131.58 29.32 129.97L66.47 48.7399C67.27 46.9899 68.44 45.4199 69.9 44.1599C71.36 42.8899 73.07 41.9499 74.92 41.3999L82.02 53.9799L92.31 72.1899L105.5 95.5499L110.41 104.22L120.86 122.73L134.88 119.91L198.31 107.16H198.32L212.4 104.32V104.34C213.21 106.1 213.63 108.01 213.63 109.94Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M212.87 104.23L212.4 104.32"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path d="M29.7397 141.04L75.9297 131.76L120.86 122.73" fill="#F5F5F5" />
      <Path
        d="M29.7397 141.04L75.9297 131.76L120.86 122.73"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path d="M120.86 122.73L140.43 157.4L147.93 170.68" fill="#F5F5F5" />
      <Path
        d="M120.86 122.73L140.43 157.4L147.93 170.68"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M175.91 39.4799L147.93 26.6799L166.57 22.8999L175.91 39.4799Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M89.0799 38.5801L82.0199 53.9801L74.9199 41.4001L89.0799 38.5801Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M89.2101 38.55L89.0801 38.5801"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M212.4 104.32L198.32 107.16L205.36 91.8L212.4 104.32Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path d="M198.31 107.16V107.17V107.18L198.3 107.19" fill="#F5F5F5" />
      <Path
        d="M198.31 107.16V107.17V107.18L198.3 107.19"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M220.06 59.69L205.36 91.8L198.32 107.16H198.31L134.88 119.91L120.86 122.73L110.41 104.22L105.5 95.55L92.31 72.19L82.02 53.98L89.08 38.58L89.09 38.55L103.78 6.46997L147.91 26.68H147.93L175.91 39.48L220.06 59.69Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M82.0201 53.98L81.9102 54.23"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M147.95 59.0499L140.28 75.7899C140.08 76.2499 140.06 76.7599 140.24 77.2299C140.41 77.6999 140.77 78.0799 141.22 78.2899C141.67 78.4999 142.19 78.5199 142.66 78.3499C143.13 78.1799 143.51 77.8299 143.73 77.3799L151.4 60.6299C151.59 60.1799 151.6 59.6599 151.42 59.1999C151.24 58.7399 150.89 58.3699 150.44 58.1599C149.99 57.9499 149.48 57.9299 149.01 58.0899C148.54 58.2499 148.16 58.5899 147.94 59.0399L147.95 59.0499Z"
        fill="#F3123C"
      />
      <Path
        d="M140.95 83.4401C140.79 83.7801 140.54 84.0701 140.22 84.2601C139.9 84.4601 139.53 84.5501 139.15 84.5401C138.78 84.5301 138.41 84.4001 138.11 84.1801C137.81 83.9601 137.57 83.6501 137.45 83.3001C137.32 82.9501 137.3 82.5701 137.39 82.2001C137.48 81.8401 137.67 81.5101 137.95 81.2501C138.23 81.0001 138.57 80.8301 138.94 80.7701C139.31 80.7101 139.69 80.7701 140.03 80.9201C140.48 81.1301 140.84 81.5201 141.01 81.9901C141.18 82.4601 141.16 82.9801 140.96 83.4401H140.95Z"
        fill="#F3123C"
      />
      <Path
        d="M143.73 77.3899C143.52 77.8399 143.13 78.1899 142.66 78.3599C142.19 78.5299 141.67 78.5099 141.22 78.2999C140.77 78.0899 140.41 77.7099 140.24 77.2399C140.06 76.7699 140.08 76.2499 140.28 75.7999L147.93 59.0599C148.15 58.6099 148.53 58.2599 149 58.0899C149.47 57.9199 149.99 57.9399 150.44 58.1499C150.89 58.3599 151.25 58.7399 151.42 59.2099C151.59 59.6799 151.58 60.1999 151.38 60.6499L143.73 77.3899V77.3899Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M140.95 83.4401C140.79 83.7801 140.54 84.0701 140.22 84.2601C139.9 84.4601 139.53 84.5501 139.15 84.5401C138.78 84.5301 138.41 84.4001 138.11 84.1801C137.81 83.9601 137.57 83.6501 137.45 83.3001C137.32 82.9501 137.3 82.5701 137.38 82.2001C137.47 81.8401 137.66 81.5101 137.94 81.2501C138.22 81.0001 138.56 80.8301 138.93 80.7701C139.3 80.7101 139.68 80.7701 140.02 80.9201C140.47 81.1301 140.83 81.5201 141 81.9901C141.17 82.4601 141.15 82.9801 140.95 83.4401V83.4401Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M160.08 102.09L108.39 80.4599C107.81 80.2199 107.72 79.4299 108.23 79.0599L155.47 45.45C155.98 45.09 156.69 45.42 156.74 46.04L161.19 101.28C161.24 101.88 160.63 102.32 160.08 102.09Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M175.93 138.74C175.21 136.29 173.91 134.05 172.17 132.19C170.42 130.32 168.26 128.9 165.86 128.02C163.47 127.14 160.9 126.83 158.36 127.12L129.11 130.43H129.05L129.03 130.44C129.03 130.44 128.94 130.38 128.93 130.38C123.24 127.68 116.58 128.29 109.79 129.18L109.81 129.12C109.81 129.12 109.79 129.12 109.78 129.13L109.76 129.18C109.19 129.39 108.63 129.63 108.08 129.9C108.08 129.9 108.06 129.89 108.01 129.88H107.99C102.19 132.74 96.33 139.92 95.24 150.71L78.33 167L38.46 205.38C39.02 205.14 39.79 205.12 40.74 205.33C41.03 205.39 41.34 205.48 41.66 205.59C42.14 205.75 42.66 205.96 43.22 206.23C43.24 206.24 43.25 206.25 43.27 206.26C48.12 208.82 52.19 212.63 55.07 217.3C55.07 217.31 55.08 217.31 55.08 217.32C55.09 217.3 55.11 217.29 55.12 217.27C55.14 217.31 55.16 217.35 55.18 217.39C55.74 218.45 56.11 219.43 56.25 220.26C56.39 220.98 56.35 221.59 56.11 222.05C56.08 222.1 56.06 222.15 56.01 222.2C56 222.23 55.98 222.26 55.96 222.28C55.95 222.31 55.93 222.35 55.9 222.38L120.48 161C129.68 161.44 142.82 156.88 151.25 153.48L150.01 159.97L142.93 197.19C142.93 197.19 142.98 197.11 143.02 197.07C143.06 197 143.11 196.93 143.18 196.86C143.23 196.78 143.31 196.71 143.38 196.65C143.45 196.56 143.52 196.5 143.6 196.44C144.33 195.81 145.38 195.32 146.6 194.95C149.91 193.93 154.41 193.73 156.83 193.87C158.71 193.98 161.88 194.41 164.2 195.34C165.59 195.9 166.68 196.64 166.99 197.59C167 197.61 167.01 197.64 167.01 197.66L176.36 146.28C176.81 143.77 176.66 141.19 175.93 138.74ZM150.02 159.99V159.96L151.28 153.48C151.88 153.24 152.46 153 153 152.77C153.55 152.54 154.06 152.32 154.55 152.11H154.56C155.05 151.9 155.51 151.7 155.93 151.51C158.08 150.57 159.38 149.94 159.47 149.89L150.02 159.99Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M118.36 99.9599C118.36 99.9599 121.85 92.4599 122.94 85.0199C122.94 85.0199 119.85 82.8199 121.52 81.3899C122.36 80.6499 123.62 81.9999 123.62 81.9999C123.62 81.9999 124.33 80.4899 123.48 79.2699C123.48 79.2699 125.53 78.7899 125.69 79.0799C125.85 79.3699 131.27 87.4899 128.12 89.4799C128.12 89.4799 127.24 89.9799 124.54 89.1599C124.54 89.1599 124.1 91.0299 126.79 94.9399C126.79 94.9399 119.51 99.9399 118.35 99.9699L118.36 99.9599Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M178.35 73.65L172.82 98.93C172.4 100.85 171.53 102.63 170.29 104.14C170.08 104.39 169.87 104.64 169.64 104.87C169.41 105.11 169.18 105.33 168.93 105.55C167.71 106.64 166.29 107.46 164.76 107.99C164.25 108.16 163.74 108.31 163.21 108.42C162.78 108.5 162.34 108.57 161.9 108.61L133.22 111.39L132.66 111.44L134.62 114.07L134.86 114.4H134.87L133.78 127.64V127.78L133.75 127.57C133.73 127.48 133.7 127.4 133.66 127.31C133.55 127.06 133.35 126.82 133.06 126.6C132.98 126.54 132.9 126.48 132.81 126.43C132.73 126.37 132.63 126.32 132.53 126.26C132.01 125.96 131.34 125.7 130.54 125.47C128.71 124.93 126.25 124.57 123.58 124.38C123.42 124.37 123.27 124.36 123.13 124.35C122.35 124.3 121.56 124.27 120.76 124.25C120.47 124.24 120.16 124.24 119.83 124.24C116.73 124.22 113.62 124.43 111.07 124.88C110.39 125 109.75 125.14 109.17 125.3C109.01 125.34 108.85 125.39 108.7 125.43C108.49 125.49 108.29 125.55 108.1 125.62C107.85 125.7 107.61 125.79 107.39 125.88C107.2 125.96 107.02 126.04 106.85 126.13C106.72 126.19 106.61 126.26 106.5 126.33C106.41 126.38 106.33 126.43 106.25 126.49C106.21 126.5 106.17 126.53 106.13 126.57C106.05 126.62 105.97 126.69 105.9 126.75C105.87 126.78 105.84 126.81 105.81 126.85C105.75 126.89 105.7 126.95 105.65 127.01C105.65 127.01 105.647 127.013 105.64 127.02C105.64 127.02 105.57 127.08 105.55 127.11H105.54C105.54 127.11 105.51 127.17 105.49 127.19L106.23 125.69L106.47 125.21L107.28 123.56H107.26C106.47 124 105.69 124.45 104.92 124.93C103.45 125.8 102.02 126.76 100.67 127.78C94.1601 133.13 88.7001 140.92 83.4501 150.87C82.3501 150.62 81.2801 150.32 80.2201 149.96C79.3601 149.67 78.5101 149.34 77.6701 148.98C77.3801 148.86 77.1001 148.73 76.8101 148.59C76.6201 148.52 76.4401 148.43 76.2601 148.33C76.0001 148.2 75.7501 148.07 75.4901 147.94C75.1301 147.75 74.7701 147.55 74.4201 147.35C73.3101 146.72 72.2401 146.01 71.2101 145.24C70.2201 144.51 69.2701 143.71 68.3701 142.86C68.3701 142.86 68.3634 142.857 68.3501 142.85C70.8701 138.79 73.2001 135.14 75.4501 131.87C79.4401 126.08 83.1701 121.51 87.2301 118.03C87.2301 118.03 95.5601 110.95 110.4 104.21C112.39 103.31 114.49 102.41 116.7 101.54C117.29 101.29 117.85 100.98 118.37 100.62C120.05 99.74 121.48 98.2 124.38 96.34C125.16 95.84 126 95.51 126.98 95.27C129.28 94.71 132.29 94.75 136.75 94.68C137.39 94.67 138.06 94.66 138.76 94.64C139.53 94.64 140.33 94.6 141.17 94.57H141.18C141.61 94.55 142.04 94.54 142.48 94.52C142.93 94.5 143.38 94.48 143.85 94.45C147.58 94.25 152.02 93.89 157.36 93.2L162.56 70.9C163.04 70.81 163.52 70.73 163.99 70.67C164.03 70.67 164.07 70.67 164.11 70.66C164.72 70.57 165.32 70.5 165.91 70.46C169.7 70.14 173.21 70.56 176.1 72.11C176.12 72.12 176.14 72.13 176.16 72.14C176.2 72.16 176.23 72.18 176.26 72.19C177 72.61 177.7 73.09 178.35 73.65Z"
        fill="#F3123C"
      />
      <Path
        d="M124.06 89.2199C124.42 90.0799 124.73 90.9299 125.13 91.7599C127.67 91.3099 128.83 90.5499 129.02 89.1499C128.71 90.2599 126.55 89.9699 124.05 89.2199H124.06Z"
        fill="#404040"
      />
      <Path
        d="M133.78 127.71V127.78C133.78 127.84 133.78 127.9 133.76 127.97C133.74 128.03 133.72 128.1 133.69 128.17C133.67 128.23 133.64 128.28 133.6 128.33C133.36 128.72 132.87 129.09 132.17 129.42C131.97 129.52 131.76 129.61 131.53 129.7C131.37 129.76 131.21 129.82 131.04 129.89C130.9 129.93 130.76 129.98 130.61 130.03C130.2 130.17 129.82 130.27 129.54 130.33C129.46 130.35 129.37 130.37 129.29 130.39C129.23 130.4 129.17 130.41 129.11 130.43H129.05L129.03 130.44L129.98 127.42L130.57 125.53C132.21 126.03 133.3 126.64 133.66 127.31C133.7 127.4 133.73 127.48 133.75 127.57C133.77 127.62 133.77 127.66 133.78 127.71Z"
        fill="#404040"
      />
      <Path
        d="M111.12 124.91L110.2 127.81L109.78 129.13L109.76 129.18C109.19 129.39 108.63 129.63 108.08 129.9C108.08 129.9 108.06 129.89 108.01 129.88H107.99C107.99 129.88 107.98 129.87 107.96 129.86C107.92 129.85 107.88 129.83 107.82 129.81C107.71 129.77 107.57 129.72 107.42 129.66C107.28 129.6 107.13 129.53 106.98 129.46C106.54 129.25 106.05 128.97 105.72 128.63C105.67 128.57 105.61 128.51 105.57 128.45C105.52 128.4 105.49 128.34 105.45 128.28C105.27 127.96 105.25 127.59 105.51 127.19C105.55 127.13 105.59 127.07 105.64 127.02C105.64 127.02 105.644 127.017 105.65 127.01C105.65 127.01 105.75 126.9 105.81 126.85C106.65 126.07 108.53 125.4 111.06 124.92C111.08 124.92 111.1 124.91 111.12 124.91Z"
        fill="#404040"
      />
      <Path
        d="M159.47 149.89L150.02 159.99V159.96L151.28 153.48C151.88 153.24 152.46 153 153 152.77C153.55 152.54 154.06 152.32 154.55 152.11H154.56C155.05 151.9 155.51 151.7 155.93 151.51C158.08 150.57 159.38 149.94 159.47 149.89Z"
        fill="#404040"
      />
      <Path
        d="M43.2199 206.23L40.7399 208.64L38.5599 210.77C38.5599 210.77 38.5299 210.72 38.5199 210.7C37.3199 208.48 37.1199 206.88 37.7099 205.99C37.7399 205.95 37.7599 205.91 37.7899 205.88C37.8199 205.84 37.8599 205.81 37.8999 205.78C37.8999 205.77 37.8999 205.76 37.9199 205.75C37.9299 205.73 37.9399 205.72 37.9499 205.71C37.9699 205.69 37.9799 205.68 37.9999 205.67C38.0199 205.65 38.0399 205.65 38.0499 205.64L38.0799 205.61C38.1799 205.53 38.2999 205.46 38.4299 205.41C38.9999 205.15 39.7699 205.13 40.7399 205.33C41.0299 205.4 41.3399 205.49 41.6599 205.59C42.1399 205.75 42.6599 205.96 43.2199 206.23Z"
        fill="#404040"
      />
      <Path
        d="M56.1102 222.05C56.1102 222.05 56.0602 222.15 56.0102 222.2C56.0002 222.23 55.9802 222.26 55.9602 222.28C55.9502 222.31 55.9302 222.35 55.9002 222.38C55.8902 222.4 55.8702 222.4 55.8602 222.42C55.8502 222.43 55.8402 222.44 55.8302 222.44C55.7202 222.56 55.6002 222.66 55.4602 222.74C55.3702 222.79 55.2802 222.83 55.1802 222.87C55.0702 222.91 54.9502 222.95 54.8202 222.97C54.7302 222.99 54.6302 223.01 54.5302 223.01C53.4202 223.11 52.0202 222.64 50.9802 222.17C50.9602 222.16 50.9302 222.15 50.9102 222.14C52.5102 220.2 54.0902 218.39 55.0802 217.32C55.0902 217.3 55.1102 217.29 55.1202 217.27C55.1402 217.31 55.1602 217.35 55.1802 217.39C55.7402 218.45 56.1102 219.43 56.2502 220.26C56.3902 220.98 56.3502 221.59 56.1102 222.05Z"
        fill="#404040"
      />
      <Path
        d="M146.63 194.95C146.45 195.98 146.28 197.03 146.11 198.05L145.63 201.05C145.45 200.98 145.27 200.9 145.09 200.81C144.98 200.75 144.86 200.7 144.75 200.64C144.34 200.43 143.98 200.2 143.67 199.94C143.59 199.87 143.51 199.8 143.43 199.73C143.42 199.72 143.4 199.7 143.39 199.7C143.25 199.56 143.13 199.43 143.02 199.29C142.91 199.15 142.83 199.01 142.76 198.86C142.73 198.81 142.71 198.76 142.69 198.7C142.66 198.6 142.63 198.49 142.62 198.38C142.61 198.33 142.61 198.28 142.61 198.23C142.61 198.15 142.62 198.08 142.63 198.01C142.66 197.76 142.75 197.52 142.87 197.3C142.89 197.27 142.91 197.24 142.93 197.21C142.96 197.16 142.98 197.12 143.02 197.07C143.06 197 143.11 196.93 143.18 196.86C143.25 196.79 143.31 196.72 143.38 196.65C143.45 196.56 143.52 196.5 143.6 196.44C144.3 195.86 145.33 195.37 146.6 194.96C146.61 194.96 146.62 194.95 146.63 194.95Z"
        fill="#404040"
      />
      <Path
        d="M167.1 198.17V198.2C167.1 198.28 167.1 198.35 167.08 198.43C167.07 198.47 167.07 198.5 167.06 198.54C167.04 198.61 167.03 198.67 167 198.73C166.97 198.82 166.94 198.9 166.9 198.98C166.59 199.59 165.95 200.11 165.23 200.51C165.13 200.57 165.02 200.63 164.92 200.68C164.91 200.69 164.9 200.69 164.89 200.7C164.68 200.8 164.48 200.9 164.28 200.98C164.17 201.03 164.06 201.07 163.96 201.11C163.78 201.19 163.58 201.26 163.38 201.33C163.37 201.33 163.35 201.34 163.34 201.34C163.33 201.35 163.31 201.36 163.3 201.36C163.54 198.99 163.94 196.92 164.15 195.35C164.17 195.36 164.18 195.36 164.2 195.37C165.68 195.99 166.66 196.75 166.99 197.59C167 197.61 167.01 197.64 167.01 197.66C167.03 197.7 167.04 197.73 167.05 197.77C167.08 197.91 167.1 198.04 167.1 198.17Z"
        fill="#404040"
      />
      <Path
        d="M172.96 233.85C172.39 234.58 171.48 234.81 170.32 234.66C170.3 234.65 170.28 234.65 170.26 234.65C167.5 234.24 163.38 231.66 159.24 228.23C159.21 228.21 159.18 228.18 159.15 228.16C153.88 223.77 148.58 218.01 146 213.6C145.97 213.56 145.95 213.52 145.92 213.47C144.86 211.65 144.28 210.06 144.37 208.91L144.42 208.59C144.51 208.14 144.74 207.76 145.1 207.49C147.52 205.68 156.1 211.86 163.14 218.81C169.16 224.75 174.04 231.27 172.96 233.85Z"
        fill="#404040"
      />
      <Path
        d="M40.94 243.96C39.65 243.91 38.4 243.51 37.32 242.81C36.92 242.55 36.55 242.25 36.21 241.91C35.75 241.46 35.36 240.96 35.04 240.4C34.96 240.26 34.89 240.12 34.82 239.98C33.88 237.92 33.03 234.55 32.17 231.34C31.92 230.38 31.66 229.44 31.4 228.55C31.14 227.65 30.88 226.82 30.61 226.08C30.48 225.72 30.36 225.35 30.25 224.98C30.16 224.64 30.07 224.29 30 223.94C29.95 223.76 29.92 223.57 29.9 223.38C29.62 221.6 29.72 219.73 30.59 218.18C31.1 218.31 31.56 218.61 31.97 219.04C32.11 219.19 32.24 219.35 32.37 219.52C32.56 219.79 32.73 220.08 32.9 220.4C33.3 221.16 33.63 222.06 33.91 223.06C34.08 223.63 34.22 224.23 34.35 224.85C34.49 225.47 34.61 226.11 34.71 226.76C34.82 227.41 34.92 228.07 35 228.73C35.04 229.06 35.08 229.39 35.12 229.72C35.74 235.06 37.75 241.87 40.94 243.96Z"
        fill="#404040"
      />
      <Path
        d="M125.7 79.0701C125.7 79.0701 124.51 75.0801 118.89 73.7701C112.21 72.0501 105.34 71.1501 98.4399 71.0901C92.9299 71.2301 90.1799 72.5601 90.6999 74.5101C90.9999 75.6001 92.2999 76.9501 94.7699 78.3701C92.0099 77.6201 89.1799 77.1901 86.3299 77.0801C81.7199 76.9101 77.7599 77.8201 80.4899 81.3801C81.3099 82.4001 82.2599 83.3201 83.2899 84.1301C81.2499 84.0301 79.2099 84.1101 77.1899 84.3701C69.0399 85.4301 68.1299 89.6001 70.2099 92.5201C73.9099 97.7201 89.6099 97.0301 92.7699 96.8701C102.47 96.4001 112.07 94.7001 121.34 91.8101C122.06 89.5101 122.59 87.1601 122.95 84.7801C119.81 82.6201 121.57 79.9801 123.16 81.7401C124.09 82.7601 123.99 80.7401 123.49 79.2701C124.2 79.0501 124.96 78.9801 125.7 79.0801V79.0701Z"
        fill="#404040"
      />
      <Path d="M132.63 111.44L134.86 114.41L135.12 111.2L132.63 111.44Z" fill="#404040" />
      <Path
        d="M102.64 126.41L106.23 125.7"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M164.89 200.7L166.81 204.12"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M122.94 84.77C121.35 92.69 119.6 97.75 118.36 100.61"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M125.13 91.76C125.53 91.44 133.76 91.55 125.62 79.01"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M127.03 95.3199C125.87 93.3499 124.87 91.2999 124.08 89.1999C126.58 89.9599 128.73 90.2399 129.04 89.1299"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M111.12 124.72L111.07 124.88L111.06 124.91"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M111.06 124.92L110.2 127.81"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M109.79 129.18L109.76 129.27"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M129.05 130.61L129.1 130.43L129.98 127.42"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M130.53 125.52L130.54 125.47L130.57 125.38"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M120.56 160.92L120.48 161"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M130.53 125.52C130.53 125.52 130.56 125.52 130.57 125.53C131.33 125.74 132 125.99 132.53 126.26C132.63 126.32 132.73 126.37 132.81 126.43C132.9 126.48 132.99 126.53 133.06 126.6C133.5 126.9 133.76 127.25 133.78 127.64C133.79 127.69 133.79 127.73 133.78 127.78C133.79 127.84 133.78 127.9 133.76 127.97C133.74 128.03 133.72 128.1 133.69 128.17C133.67 128.23 133.64 128.28 133.6 128.33C133.36 128.72 132.87 129.09 132.17 129.42C131.97 129.52 131.76 129.61 131.53 129.7C131.37 129.76 131.21 129.82 131.04 129.89C130.9 129.93 130.76 129.98 130.61 130.03C130.27 130.13 129.92 130.23 129.54 130.33C129.46 130.35 129.37 130.37 129.29 130.39C129.23 130.4 129.17 130.41 129.11 130.43"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M120.76 124.25C121.15 124.25 121.49 124.26 121.79 124.27C122.15 124.28 122.61 124.31 123.13 124.35"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M107.99 129.87C107.99 129.87 107.98 129.87 107.96 129.86C107.92 129.85 107.88 129.83 107.82 129.81C107.71 129.77 107.57 129.72 107.42 129.66C107.28 129.6 107.13 129.53 106.98 129.46C106.54 129.25 106.05 128.97 105.72 128.63C105.67 128.57 105.61 128.51 105.57 128.45C105.52 128.4 105.49 128.34 105.45 128.28C105.27 127.96 105.25 127.59 105.51 127.19C105.55 127.13 105.59 127.07 105.64 127.02C105.64 127.02 105.644 127.017 105.65 127.01C105.7 126.95 105.75 126.89 105.81 126.85C105.84 126.81 105.87 126.78 105.9 126.75C105.97 126.69 106.05 126.62 106.13 126.57C106.17 126.53 106.21 126.5 106.25 126.49C106.33 126.42 106.41 126.37 106.5 126.33C106.61 126.25 106.73 126.19 106.85 126.13C107.02 126.04 107.2 125.96 107.39 125.88C107.61 125.78 107.85 125.7 108.1 125.62C108.29 125.55 108.49 125.49 108.7 125.43C108.85 125.39 109.01 125.34 109.17 125.3C109.76 125.15 110.39 125.02 111.06 124.91"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M150 159.99L150.01 159.97L150.03 159.96L159.47 149.89"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M155.93 151.51C155.51 151.7 155.05 151.9 154.56 152.11"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M154.55 152.11C154.07 152.32 153.55 152.54 153 152.77"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M108.33 140.75C108.33 140.75 105.26 150.07 110.55 156.48C111.33 157.43 112.31 158.32 113.51 159.11C115.33 160.3 117.73 160.87 120.48 161"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M142.93 197.19V197.21L142.83 197.73"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M79.25 149.71C76.27 152.11 73.1 154.26 69.77 156.13H69.76C68.51 156.86 67.24 157.53 65.94 158.16C64.61 158.82 63.21 159.34 61.77 159.73C61.72 159.74 61.67 159.76 61.62 159.77C57.76 160.83 57.78 160.2 60.74 158.01C61.01 157.81 61.27 157.61 61.53 157.41C61.53 157.41 61.53 157.407 61.53 157.4C63.24 156.05 64.8 154.55 66.22 152.89C67.46 151.34 68.59 149.72 69.62 148.04C70.18 147.12 70.7 146.19 71.2 145.24C72.23 146.01 73.3 146.72 74.41 147.35C74.76 147.55 75.12 147.75 75.48 147.94C76.69 148.61 77.95 149.22 79.24 149.71H79.25Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M79.29 149.68C79.29 149.68 79.26 149.7 79.25 149.71"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M71.22 145.22C71.22 145.22 71.21 145.23 71.21 145.24"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M80.15 150.04C77.46 153.86 74.95 157.89 72.71 162.01C72.25 162.98 71.86 163.69 71.53 164.19C70.06 166.4 69.74 164.64 69.89 162.96C70.1 160.62 71.74 155.71 69.77 156.13C73.1 154.26 76.27 152.11 79.25 149.71C79.55 149.83 79.85 149.94 80.15 150.04Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M80.2402 149.92C80.2402 149.92 80.2202 149.95 80.2202 149.96H80.2102C80.2102 149.96 80.1702 150.01 80.1602 150.04"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M69.7702 156.13H69.7602C69.6502 156.15 69.5402 156.19 69.4102 156.25"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M69.6304 148.04C68.6004 149.72 67.4704 151.34 66.2304 152.89C64.8104 154.55 63.2504 156.05 61.5404 157.4C61.5404 157.4 61.5404 157.403 61.5404 157.41C59.8704 158.16 58.0204 158.77 56.2704 159.23C52.6604 160.1 52.6604 159.04 53.1804 158.73C54.3104 158.06 55.8804 157.27 57.3704 156.5C58.5704 155.88 59.7104 155.29 60.5404 154.76C62.8704 153.27 65.1204 151.67 67.2904 149.96C67.2904 149.96 67.2904 149.95 67.3104 149.95C68.1004 149.33 68.8804 148.69 69.6404 148.04H69.6304Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M61.88 157.25C61.77 157.3 61.66 157.35 61.54 157.4"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M68.1203 149.42C67.8503 149.6 67.5803 149.78 67.3003 149.95"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M67.2801 149.96C65.1101 151.67 62.8601 153.27 60.5301 154.76C59.7001 155.29 58.5601 155.88 57.3601 156.5C56.9101 156.57 56.7401 156.55 56.4701 156.57C52.7401 157.11 52.8401 156.04 53.3801 155.78C55.5401 154.76 58.8901 153.6 60.9601 152.77C63.1101 152.1 65.3301 151.15 67.2801 149.96Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M57.6104 156.47C57.5204 156.48 57.4304 156.5 57.3604 156.5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M165.91 70.4599V70.4299"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M172.28 52.74C172.28 52.74 172.27 52.75 172.27 52.76"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M172.85 56.8899C172.85 56.8899 172.8 56.9599 172.78 56.9899"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M172.28 52.74C172.28 52.74 172.27 52.75 172.27 52.76C171.01 54.53 169.83 56.15 169.02 57.08"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M175.11 59.1599L175.08 59.1899"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M172.85 56.8899C172.3 57.3899 171.77 57.8699 171.28 58.2899"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M175.62 67.51C176.31 68.97 176.53 70.6 176.26 72.19C176.23 72.18 176.2 72.16 176.16 72.14C176.14 72.14 176.12 72.12 176.1 72.11C173.09 70.45 169.65 70.06 165.91 70.43C165.88 69.95 165.84 69.3 165.79 68.56V68.54C165.65 66.32 165.45 63.25 165.5 61.21C165.52 60.39 165.58 59.73 165.7 59.36C165.86 58.77 169.91 52.74 171.8 49.81C173.26 47.56 174.77 46.96 172.28 52.74C173.78 50.61 175.36 48.27 176.48 46.68C177.43 45.33 178.37 48.58 172.85 56.89C174.62 55.23 176.62 53.21 178.5 51.36C179.66 50.22 181.04 52.13 175.11 59.16C176.69 58.56 178.36 57.92 180.75 56.79C182.16 56.14 182.21 58.19 175.29 63.47C174.01 64.44 174.77 65.42 175.62 67.51Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M175.11 59.1599C174.69 59.3099 174.28 59.4599 173.87 59.6199"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M165.79 68.5399C165.13 66.1199 164.16 63.7899 162.94 61.5899C160.47 56.6499 162.44 57.2499 163.63 58.5299C164.36 59.3199 165.03 60.2399 165.5 61.2099C165.45 63.2499 165.65 66.3199 165.79 68.5399Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M165.52 61.25C165.52 61.25 165.51 61.22 165.5 61.21"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M165.79 68.54V68.56L165.82 68.65"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M38.4599 205.38C38.3199 205.44 38.1999 205.51 38.0899 205.59V205.61C38.0899 205.61 38.0299 205.64 37.9999 205.67C37.9799 205.68 37.9699 205.69 37.9499 205.71C37.9499 205.72 37.9299 205.73 37.9199 205.75C37.8699 205.78 37.8299 205.83 37.7899 205.88C37.7599 205.91 37.7399 205.95 37.7099 205.99C37.1199 206.88 37.3199 208.48 38.5199 210.69"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M50.8604 222.17C50.8604 222.17 50.9204 222.2 50.9504 222.21C52.4304 222.87 53.6403 223.12 54.5303 223.01C54.6303 223.01 54.7304 222.99 54.8204 222.97C54.9504 222.95 55.0704 222.91 55.1804 222.87C55.2804 222.83 55.3704 222.79 55.4604 222.74C55.6004 222.66 55.7204 222.56 55.8304 222.44C55.8804 222.39 55.9204 222.34 55.9604 222.28"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M56.0101 222.2C56.3101 221.73 56.3901 221.08 56.2501 220.26C56.1001 219.46 55.7401 218.51 55.1401 217.43C55.1201 217.39 55.1001 217.36 55.0801 217.32"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M171.38 234.78C171.05 234.78 170.7 234.74 170.32 234.66C171.48 234.81 172.39 234.58 172.96 233.85C174.04 231.27 169.16 224.75 163.14 218.81C156.1 211.86 147.52 205.68 145.1 207.49C144.74 207.76 144.51 208.14 144.42 208.59L145.63 201.05L146.11 198.05C146.28 197.03 146.45 195.98 146.63 194.95C146.62 194.95 146.61 194.96 146.6 194.96C149.91 193.93 154.41 193.73 156.83 193.87C158.71 193.98 161.88 194.41 164.2 195.34V195.37C164.2 195.37 164.17 195.36 164.15 195.35C163.94 196.92 163.54 198.99 163.3 201.36C163.31 201.36 163.33 201.35 163.34 201.34C163.34 201.34 163.37 201.33 163.38 201.33C163.27 202.4 163.2 203.52 163.19 204.66C163.13 209.24 164.06 214.24 167.81 218.94C173.19 225.63 175.93 234.78 171.38 234.78Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M142.93 197.19C142.93 197.19 142.88 197.26 142.87 197.3C142.84 197.34 142.81 197.39 142.79 197.43C142.65 197.71 142.59 197.97 142.61 198.23C142.61 198.28 142.61 198.33 142.62 198.38C142.63 198.49 142.66 198.6 142.69 198.7C142.71 198.76 142.73 198.81 142.76 198.86C142.83 199.01 142.91 199.15 143.02 199.29C143.13 199.43 143.25 199.56 143.39 199.7C143.4 199.7 143.42 199.72 143.43 199.73L143.67 199.94C143.99 200.2 144.37 200.43 144.75 200.64C144.86 200.7 144.98 200.75 145.09 200.81C145.27 200.9 145.45 200.98 145.63 201.05"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M163.38 201.33C163.57 201.26 163.76 201.19 163.96 201.11C164.06 201.07 164.17 201.03 164.28 200.98C164.48 200.9 164.68 200.8 164.89 200.7C164.9 200.69 164.91 200.69 164.92 200.68C165.02 200.63 165.13 200.57 165.23 200.51C165.95 200.11 166.59 199.59 166.9 198.98C166.94 198.9 166.97 198.82 167 198.73C167.03 198.67 167.04 198.61 167.06 198.54C167.07 198.5 167.07 198.47 167.08 198.43C167.09 198.35 167.09 198.28 167.1 198.2V198.17C167.1 198.04 167.08 197.91 167.05 197.77C167.05 197.73 167.03 197.7 167.01 197.66"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M164.23 195.15C164.22 195.21 164.21 195.27 164.2 195.34"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M164.2 195.37C163.95 197.13 163.6 199.15 163.38 201.32"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M170.32 234.66C170.32 234.66 170.28 234.65 170.26 234.65C166.82 233.88 161.59 230.1 159.24 228.23C159.21 228.21 159.18 228.18 159.15 228.16C154.88 224.71 148.88 218.96 146 213.6C145.97 213.56 145.95 213.52 145.92 213.47C145.09 211.89 144.53 210.35 144.37 208.91L144.42 208.59"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M146.6 194.96L146.11 198.05"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M146.63 194.76L146.6 194.95"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M29.9001 223.38C29.8601 223.16 29.8401 222.93 29.8101 222.71C29.8401 222.93 29.8601 223.16 29.9001 223.38Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M29.81 222.71C29.79 222.54 29.78 222.37 29.77 222.2C29.78 222.31 29.79 222.42 29.8 222.53C29.8 222.59 29.8 222.65 29.81 222.71Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M51.5301 241.74C51.8101 242.85 51.3201 243.96 50.1501 243.96H40.9401C37.7501 241.87 35.7401 235.06 35.1201 229.72C35.0801 229.39 35.0401 229.06 35.0001 228.73C34.9201 228.07 34.8201 227.41 34.7101 226.76C34.6101 226.11 34.4901 225.47 34.3501 224.85C34.2201 224.23 34.0701 223.63 33.9101 223.06C33.6301 222.06 33.3001 221.16 32.9001 220.4C32.7301 220.08 32.5601 219.79 32.3701 219.52C32.2401 219.35 32.1101 219.19 31.9701 219.04C31.5601 218.61 31.1001 218.31 30.5901 218.18C30.3701 218.58 30.2001 219 30.0701 219.43C30.0301 219.54 30.0001 219.65 29.9801 219.76C29.9601 219.82 29.9501 219.89 29.9301 219.96C29.8801 220.19 29.8401 220.43 29.8201 220.67C29.7801 221.01 29.7601 221.35 29.7601 221.7C29.7601 221.87 29.7601 222.03 29.7701 222.2C29.6301 220.03 30.1701 217.98 31.8901 216.56C33.2301 215.45 35.8501 213.14 38.5201 210.7C38.5301 210.72 38.5501 210.75 38.5601 210.77L40.7401 208.64C41.6301 207.81 42.4901 207 43.2701 206.26C48.1201 208.82 52.1901 212.63 55.0701 217.3C55.0701 217.31 55.0801 217.31 55.0801 217.32C54.0901 218.39 52.5101 220.2 50.9101 222.14C50.9301 222.15 50.9601 222.16 50.9801 222.17C50.9701 222.18 50.9501 222.2 50.9501 222.21C48.9301 224.6 46.9701 227.17 46.2501 228.89C45.5101 231.19 45.1201 233.59 45.1101 236.01C48.5601 237.67 50.9501 239.43 51.5301 241.74Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M55.29 217.27C55.29 217.27 55.22 217.35 55.18 217.39C55.17 217.4 55.16 217.42 55.14 217.43C54.09 218.59 52.52 220.32 50.98 222.17"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M40.9399 243.96C39.6499 243.91 38.3999 243.51 37.3199 242.81C36.9199 242.55 36.5499 242.25 36.2099 241.91C35.7499 241.47 35.3599 240.96 35.0399 240.4C34.9599 240.26 34.8799 240.12 34.8099 239.98C33.8699 237.92 33.0199 234.55 32.1699 231.34C31.9099 230.38 31.6499 229.44 31.3999 228.55C31.1399 227.65 30.8799 226.82 30.6099 226.08C30.4799 225.72 30.3599 225.35 30.2499 224.98C30.1499 224.63 30.0699 224.29 29.9999 223.94C29.9499 223.76 29.9199 223.57 29.8999 223.38"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M38.52 210.7C39.26 210.01 40.01 209.32 40.74 208.64"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M43.46 206.07L43.27 206.26"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M35 228.73C34.92 228.07 34.82 227.41 34.71 226.76"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M34.3499 224.85C34.2199 224.23 34.0699 223.63 33.9099 223.06C33.6199 222.06 33.2899 221.16 32.8999 220.4"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M32.3702 219.52C32.2402 219.35 32.1102 219.19 31.9702 219.04"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M30.5901 218.18H30.5801"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M125.7 79.0701C125.7 79.0701 124.48 75.0601 118.89 73.7701C112.21 72.0501 105.34 71.1501 98.4399 71.0901C92.9299 71.2301 90.1699 72.5601 90.6999 74.5101C90.9999 75.6301 92.3899 76.9801 94.9699 78.4301C95.6799 78.6701 96.1299 78.8801 96.1999 79.0701C95.7699 78.8601 95.3499 78.6401 94.9699 78.4301C92.1499 77.6401 89.2499 77.1801 86.3199 77.0801C81.7099 76.9101 77.7599 77.8101 80.4799 81.3801C81.3099 82.4001 82.2499 83.3201 83.2799 84.1301C81.2399 84.0301 79.1999 84.1101 77.1799 84.3701C72.9799 84.9301 68.2999 86.5401 69.5099 91.0701C69.6499 91.5901 69.8799 92.0801 70.1999 92.5201C73.8999 97.7301 89.5999 97.0301 92.7599 96.8701C106.94 96.1401 121.46 92.3901 121.44 91.7701C122.15 89.4701 122.59 87.1601 122.95 84.7801C119.81 82.6201 121.57 79.9801 123.16 81.7401C124.09 82.7601 123.99 80.7401 123.49 79.2701C124.2 79.0501 124.96 78.9801 125.7 79.0801V79.0701Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M134.86 114.41L132.63 111.44L135.12 111.2"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M114.2 109.23L105.51 127.19"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M165.91 70.4299C165.32 70.4799 164.72 70.5599 164.11 70.6599C164.07 70.6599 164.03 70.6599 163.99 70.6599C163.52 70.7399 163.05 70.8299 162.58 70.9199L157.36 93.1899C152.02 93.8799 147.58 94.2399 143.85 94.4399C143.38 94.4699 142.93 94.4899 142.48 94.5099C142.04 94.5299 141.61 94.5399 141.18 94.5599H141.17C140.33 94.5899 139.53 94.6199 138.76 94.6299C138.06 94.6499 137.39 94.6599 136.75 94.6699C132.29 94.7499 129.29 94.7199 126.99 95.2799C126.02 95.5099 125.17 95.8499 124.39 96.3499C121.49 98.1999 120.07 99.7499 118.38 100.63C117.86 100.99 117.3 101.3 116.72 101.55C97.9601 108.94 87.2501 118.04 87.2501 118.04C80.8901 123.47 75.3501 131.62 68.3701 142.85C69.2701 143.7 70.2201 144.5 71.2101 145.23"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M107.28 123.56H107.26C106.47 124 105.69 124.45 104.92 124.93C104.15 125.4 103.4 125.89 102.65 126.41H102.64C101.98 126.86 101.33 127.33 100.69 127.81C94.1902 133.15 88.7202 140.94 83.4702 150.89C82.3602 150.64 81.2702 150.42 80.2002 150.06C80.1802 150.05 80.1702 150.05 80.1602 150.04"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M176.16 72.1399C176.92 72.5699 177.65 73.0699 178.35 73.6599L172.82 98.9299C172.4 100.85 171.53 102.63 170.29 104.14C170.08 104.39 169.87 104.64 169.64 104.87C169.41 105.11 169.18 105.33 168.93 105.55C167.71 106.64 166.29 107.46 164.76 107.99C163.83 108.31 162.87 108.53 161.89 108.62L135.13 111.21H135.12L134.86 114.4L133.78 127.64V127.78"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M130.53 125.52L129.98 127.42L129.03 130.43C129.03 130.43 128.94 130.38 128.93 130.38C123.24 127.68 116.58 128.29 109.79 129.18L109.81 129.12L110.2 127.81L111.12 124.91C111.12 124.91 111.08 124.92 111.06 124.92C113.98 124.41 117.41 124.25 119.83 124.24C120.16 124.24 120.47 124.24 120.76 124.25C121.56 124.27 122.35 124.3 123.13 124.35C123.27 124.36 123.42 124.37 123.58 124.38C125.59 124.56 128.38 124.91 130.53 125.52Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M109.81 129.12C109.9 129.08 109.99 129.05 110.08 129.02H110.11"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M109.78 129.13C109.3 129.29 108.81 129.49 108.32 129.71C108.21 129.76 108.11 129.81 108 129.87H107.99"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M38.4602 205.38L38.4302 205.41L38.4102 205.43L38.3702 205.47L38.2202 205.62"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M166.95 198.2V198L167.01 197.66"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M129.05 130.44C129.05 130.44 129.05 130.44 129.03 130.43"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M125.17 129.09C125.17 129.09 116.98 140.3 122.42 146.57C127.71 152.67 151.73 144.89 163.74 140.49C164.43 140.24 165.18 140.17 165.91 140.3C166.64 140.43 167.32 140.75 167.88 141.22C168.45 141.69 168.88 142.31 169.13 143C169.38 143.69 169.45 144.44 169.32 145.17"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M169.33 145.17L160.59 193.83"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M110.57 156.47L50.8901 211.93"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M159.35 92.99L157.36 93.2"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_8462_168397">
        <Rect width={216} height={238.44} fill="white" transform="translate(17 6)" />
      </ClipPath>
    </Defs>
  </Svg>
)

export const EmailNotConfirmed = memo(EmailNotConfirmedIllustration)
